import React from 'react';
import { Box, Typography, Card, CardContent, Button, Grid } from '@mui/joy';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../../components/common/PageHeader';

export const AdminSettingsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <PageHeader title="System administration" description="Open platform tools for managing organizations and the affiliate program." />

      <Grid container spacing={3}>
        <Grid xs={12} md={6}>
          <Card variant="outlined">
            <CardContent>
              <Typography level="h4" sx={{ mb: 2 }}>
                Affiliate Management
              </Typography>
              <Typography level="body-md" sx={{ mb: 2, color: 'text.secondary' }}>
                Manage affiliate applications, approvals, and program settings.
              </Typography>
              <Button
                variant="solid"
                color="primary"
                onClick={() => navigate('/manage/affiliates')}
              >
                Manage Affiliates
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid xs={12} md={6}>
          <Card variant="outlined">
            <CardContent>
              <Typography level="h4" sx={{ mb: 2 }}>
                Organizations & support
              </Typography>
              <Typography level="body-md" sx={{ mb: 2, color: 'text.secondary' }}>
                Review client organizations, onboarding progress, account health, and support activity.
              </Typography>
              <Button variant="outlined" color="primary" onClick={() => navigate('/manage/dashboard')}>
                Open platform admin
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>


    </Box>
  );
};
